import BConfig from "./BConfig";

export default class BAuth
{
	static getAccessToken()
	{
		return BConfig.getAccessToken();
	}

	static getAuthorizationHeader()
	{
		let accessToken = this.getAccessToken();
		if (accessToken) {
			return "Bearer " + this.getAccessToken();
		}

		return false;
	}
}
